import {Component, EventEmitter, Input, OnInit, Output, SecurityContext} from '@angular/core';
import {TicketArticle} from '../../../model/Ticket';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {DecodeBase64Pipe} from '../../common/DecodeBase64Pipe';
import {CidTransformPipe} from '../../common/CidTransformPipe';
import {EmojiPipe} from '../../common/EmojiPipe';
import {AvatarComponent} from "../avatar/avatar.component";
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";
import {AttachmentDownloaderComponent} from "../attachment-downloader/attachment-downloader.component";

@Component({
    selector: 'app-ticket-article',
    templateUrl: './ticket-article.component.html',
    imports: [
        CommonModule,
        AvatarComponent,
        FaIconComponent,
        NgbCollapse,
        AttachmentDownloaderComponent
    ],
    styleUrls: ['./ticket-article.component.css']
})
export class TicketArticleComponent implements OnInit {

  @Input() article: TicketArticle;
  @Input() reduced = false;
  @Input() ticketId: string;
  @Output() reducedChange = new EventEmitter<boolean>();

  htmlContent: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.htmlContent = this.sanitizer.sanitize(
      SecurityContext.HTML,
      new EmojiPipe().transform(
        new CidTransformPipe().transform(
          new DecodeBase64Pipe().transform(this.article.base64body),
          this.article.attachments)));

    this.article.from = this.getFromName(this.article.from);
    this.article.attachments = this.article.attachments.sort((a, b): number => {
      return a.filename.toLowerCase().localeCompare(b.filename.toLowerCase());
    });
  }

  getFromName(from: string): string {
    const match = from.match(/"(.*?)"/);
    return match !== null && match.length > 1 ? match[1] : from;
  }

  toggle(): void {
    this.reduced = !this.reduced;
    this.reducedChange.emit(this.reduced);
  }

}
